module.exports = __webpack_public_path__ + "media/images/mark-green-bg-528129d0ba8384700b8ba1137cf8ab38.svg";